import { render } from "./ArtworkFilters.vue?vue&type=template&id=0e80f7ea&scoped=true"
import script from "./ArtworkFilters.vue?vue&type=script&lang=js"
export * from "./ArtworkFilters.vue?vue&type=script&lang=js"

import "./ArtworkFilters.vue?vue&type=style&index=0&id=0e80f7ea&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e80f7ea"]])

export default __exports__